import { render, staticRenderFns } from "./UserPay.vue?vue&type=template&id=152f8234&scoped=true"
import script from "./UserPay.vue?vue&type=script&lang=js"
export * from "./UserPay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "152f8234",
  null
  
)

export default component.exports